import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
// Components
import { Button } from 'app/components/Mui';
// Hooks
import useToggle from 'app/hooks/useToggle';
import useAccountStatus from 'app/hooks/useAccountStatus';
//
import ContactsFormDialog from './ContactsFormDialog';

const ContactsCreateButton:FC = () => {
  const { t } = useTranslation();

  const { isSuspended } = useAccountStatus();
  const { open, toggle } = useToggle();
  return (
    <Fragment>
      <Button
        name="Create contact"
        onClick={toggle}
        variant="contained"
        disabled={isSuspended}
      >{t('pages.contacts.createButton')}</Button>
      {/* Dialog */}
      {open ? (
        <ContactsFormDialog
          open={open}
          onClose={toggle}
        />
      ) : null}
    </Fragment>
  )
}

export default ContactsCreateButton;
